// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EIZE","select":"styles_select__2dgMG"};